// extracted by mini-css-extract-plugin
export default {"activeMarkerContainer":"active-marker-module__activeMarkerContainer--obY1m"};